import { put, select, take } from 'redux-saga/effects';
import notification from 'antd/lib/notification';
// internal
import history from '@app/components/router/history';
import * as ActionType from '@app/store/typings/actions/project.d';
import * as projectService from '@app/services/project';
import { handleError } from '@app/utils/service';
import { RootState } from '@app/store/typings/state/root';

export function* RoleInProjectWithId({ payload }: ActionType.RoleProjectWithId) {
  try {
    const { data } = yield projectService.fetchRoleInProjectWithId(
      payload.projectId,
      payload.roleId,
    );
    if (data.success) {
      yield put<ActionType.ProjectType>({
        type: 'KEY_PROJECT_SET_CURRENTROLE',
        payload: data.data,
      });
    }
  } catch (error) {
    handleError(error);
  }
}

export function* listRolesInProject({ payload }: ActionType.ListRolesProject) {
  try {
    const check: boolean = yield select((state: RootState) => state.project.currentProject._id);
    if (!check) {
      yield take('KEY_PROJECT_SET_WITHID');
    }
    const projectId: string = yield select((state: RootState) => state.project.currentProject._id);
    const { data } = yield projectService.listRoles(
      projectId,
      payload.offset,
      payload.limit,
      payload.brief,
    );
    if (data.success) {
      yield put<ActionType.ProjectType>({
        type: 'KEY_PROJECT_SET_LISTROLES',
        payload: {
          data: data.data,
          meta: data.meta,
        },
      });
    }
  } catch (error) {
    handleError(error);
  }
}

export function* createRoleInProject({ payload }: ActionType.CreateRoleProject) {
  try {
    const projectId: string = yield select((state: RootState) => state.project.currentProject._id);
    const { data } = yield projectService.createRoleInProject(
      projectId,
      payload.roleName,
      payload.permission,
    );
    if (data.success) {
      notification.success({ message: 'Success', description: 'Create role successfully' });
      const subpath = history.location.pathname.split('/');
      const pathname = subpath.slice(0, subpath.length - 1).join('/');
      history.push(pathname);
    }
  } catch (error: any) {
    const message = error.response.data.message;
    notification.error({ message: 'Error', description: message });
    handleError(error);
  }
}

export function* updateRoleInProject({ payload }: ActionType.UpdateRoleProject) {
  try {
    const projectId: string = yield select((state: RootState) => state.project.currentProject._id);
    const roleId: string = yield select(
      (state: RootState) => state.project.listRole.currentRole?._id,
    );
    const { data } = yield projectService.updateRoleInProject(
      projectId,
      roleId,
      payload.roleName,
      payload.permission,
    );
    if (data.success) {
      notification.success({ message: 'Success', description: 'Update role successfully' });
      const subpath = history.location.pathname.split('/');
      const pathname = subpath.slice(0, subpath.length - 1).join('/');
      history.push(pathname);
    }
  } catch (error: any) {
    const message = error.response.data.message;
    notification.error({ message: 'Error', description: message });
    handleError(error);
  }
}

export function* deleteRolesInProject({ payload }: ActionType.DeleteRolesProject) {
  try {
    const projectId: string = yield select((state: RootState) => state.project.currentProject._id);
    const offset: number = yield select((state: RootState) => state.project.listRole.meta.offset);
    const total: number = yield select((state: RootState) => state.project.listRole.meta.total);
    const limit: number = yield select((state: RootState) => state.project.listRole.meta.limit);
    const realOffset =
      offset === total - payload.roleId.length && offset !== 0 ? offset - limit : offset;
    let count = 0;
    for (let i = 0; i < payload.roleId.length; i++) {
      const { status } = yield projectService.deleteRolesInProject(projectId, payload.roleId[i]);
      if (status === 204) {
        count += 1;
      }
    }
    if (count === payload.roleId.length) {
      notification.success({ message: 'Success', description: 'Delete role successfully' });
      yield put<ActionType.ProjectType>({
        type: 'KEY_PROJECT_LISTROLES',
        payload: {
          offset: realOffset,
          limit: limit,
        },
      });
    }
  } catch (error: any) {
    const message = error.response.data.message;
    notification.error({ message: 'Error', description: message });
    handleError(error);
  }
}
